import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ComplaintManagement from './ComplaintManagement';
import TenantComplaints from './TenantComplaints';

/** Staff/admin hostel complaints vs tenant self-service. */
const ComplaintsRouter: React.FC = () => {
  const { isResident, isStaff, isHostelAdmin, isSuperAdmin } = useAuth();

  if (isResident()) {
    return <TenantComplaints />;
  }

  if (isStaff() || isHostelAdmin() || isSuperAdmin()) {
    return <ComplaintManagement />;
  }

  return <Navigate to="/dashboard" replace />;
};

export default ComplaintsRouter;
